function debounce(func, wait) {
  var t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => func.apply(this, args), wait);
  };
}

(() => {
  if (typeof window.CustomEvent === "function") {
    return false;
  }

  function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: null,
    };
    var evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(
      event,
      params.bubbles,
      params.cancelable,
      params.detail
    );
    return evt;
  }

  window.CustomEvent = CustomEvent;
})();

class ScrollTo extends HTMLElement {
  constructor() {
    super();

    this.settings = {
      extraSpacing: 50,
    };
  }

  get findTarget() {
    if (!this.hasAttribute("scroll-to")) return null;
    var queryString = this.getAttribute("scroll-to").replaceAll("'", '"'); // Since we cant use " in the DOM attribute, use ' instead
    var target = document.querySelector(queryString);
    return target || undefined;
  }

  set setTarget(ele) {
    if (ele) {
      this.target = ele;
    }
  }

  navigationRect() {
    if (!this.navRect) {
      var nav = document.querySelector("header-nav");
      if (nav) {
        this.nav = nav;
        this.navRect = nav.getBoundingClientRect();
      }
    }

    if (this.nav) {
      var currentRect = this.nav.getBoundingClientRect();
      if (this.navRect.bottom !== currentRect.bottom) {
        this.navRect = currentRect;
      }
    }

    return this.navRect.bottom || 0;
  }

  triggerCallback() {
    // If no target - try and find a target
    if (!this.target) {
      this.setTarget = this.findTarget;
    }

    // Still no target?
    if (!this.target) return;

    if (this.target.nodeName === "WDN-DROPDOWN") {
      this.target.setActive();
    }

    var navYPosition = this.navigationRect();
    var targetYPosition =
      this.target.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: targetYPosition - navYPosition - this.settings.extraSpacing,
      behavior: "smooth",
    });
  }

  connectedCallback() {
    this.addEventListener("click", this.triggerCallback);
  }
}

customElements.define("scroll-to", ScrollTo);

class SlideText extends HTMLElement {
  constructor() {
    super();
  }

  startIgnoreTimer() {
    this.ignore = true;
    setTimeout(() => {
      this.ignore = false;
    }, this.animationSpeed);
  }

  tick(dir) {
    if (this.ignore) {
      return;
    }

    this.startIgnoreTimer();

    if (this.direction == "prev") {
      this.classList.add("mode--prev", "no-anim");
      if (!this.classList.contains("mode--prev")) {
        requestAnimationFrame(this.tick);
        return;
      }
    } else {
      this.classList.remove("mode--prev");
    }

    this.classList.remove("no-anim");

    var justSlidedOut = this.querySelectorAll(".slide-out");

    justSlidedOut.forEach((elem) => {
      elem.classList.remove("slide-out");
    });

    var active = this.items[this.activeIndex];
    active.classList.remove("active");
    active.classList.add("slide-out");

    var nextItem = this.items[this.activeIndex + 1];

    if (this.direction == "prev") {
      nextItem = this.items[this.activeIndex - 1];
    }

    if (!nextItem) {
      if (this.direction == "prev") {
        nextItem = this.items[this.itemCount - 1]; // last item
      } else {
        nextItem = this.items[0];
      }
    }

    nextItem.classList.add("slide-in");

    if (this.direction == "prev") {
      this.activeIndex = this.activeIndex - 1;
      if (this.activeIndex < 0) {
        this.activeIndex = this.itemCount - 1;
      }
    } else {
      this.activeIndex = this.activeIndex + 1;
      if (this.activeIndex >= this.itemCount) {
        this.activeIndex = 0;
      }
    }

    /* active == prev active... */
    setTimeout(() => {
      active.classList.remove("slide-out");
      nextItem.classList.add("active");
      nextItem.classList.remove("slide-in");
    }, this.animationSpeed);

    this.directionChanged = false;
  }

  nextTick() {
    if (this.direction == "prev") {
      this.directionChanged = true;
      this.newDirection = "next";
    }
    this.direction = "next";
    this.tick();
  }

  prevTick() {
    if (this.direction == "next") {
      this.directionChanged = true;
      this.newDirection = "prev";
    }

    this.direction = "prev";
    this.tick();
  }

  autoTick() {
    setInterval(() => {
      this.direction = "next";
      this.tick();
    }, this.slideInterval);
  }

  connectedCallback() {
    this.slideInterval = 5000;

    this.animationSpeed = parseInt(
      window.getComputedStyle(this).getPropertyValue("--transition-speed")
    );

    if (this.hasAttribute("data-slide-interval")) {
      this.slideInterval = parseInt(this.getAttribute("data-slide-interval"));
    }

    this.classList.remove("no-anim", "pre-init");
    this.items = this.querySelectorAll(".slide-item");

    this.tallestElemHeight = 0;

    this.items.forEach((elem) => {
      var elemRect = elem.getBoundingClientRect();
      if (elemRect.height > this.tallestElemHeight) {
        this.tallestElemHeight = elemRect.height;
      }
    });

    this.style.height = this.tallestElemHeight + "px";

    this.itemCount = this.items.length;
    this.activeIndex = 0;

    if (this.hasAttribute("data-autotick")) {
      this.autoTick();
    }

    if (this.hasAttribute("data-autotick-on-less")) {
      if (
        window.innerWidth < parseInt(this.getAttribute("data-autotick-on-less"))
      ) {
        this.autoTick();
      }
    }
  }
}

customElements.define("slide-text", SlideText);
